module.exports = "data:image/png;base64,UklGRqIAAABXRUJQVlA4WAoAAAAQAAAACgAACgAAQUxQSCUAAAABHyAgSUPg74qIyKAashUKIIQgQsjf6N35DSGi/xHIYeCfwxIFAFZQOCBWAAAA8AEAnQEqCwALAAIANCWkAALc91ndN2BAAP74RpiOKP8ij0ns0Xe1XJktPrrUvf+hl7AyIDTaro1XlX/dZLU/r9v3vFmx3ctLTM/bvybYkZZAsoEPgAA="


//////////////////
// WEBPACK FOOTER
// ./src/Assets/nodes/DelegatePin_Disconnected.png
// module id = 31
// module chunks = 0